import type { PortalActivity, PortalMetric } from '../data/portal-model';

interface ActivityOverviewProps {
  activity: PortalActivity;
  metrics: PortalMetric[];
}

export function ActivityOverview({ activity, metrics }: ActivityOverviewProps) {
  return (
    <section id="overview" aria-labelledby="overview-heading">
      <div className="page-heading">
        <div>
          <p className="eyebrow">Release 3.0 foundation</p>
          <h1 id="overview-heading">Operations overview</h1>
          <p>One controlled view of the next synthetic activity and its operational limits.</p>
        </div>
        <button
          type="button"
          disabled
          title="Activity creation is enabled after the synthetic foundation is approved"
        >
          Create activity
        </button>
      </div>

      <div className="metric-grid" aria-label="Activity metrics">
        {metrics.map((metric) => (
          <article className={`metric-card metric-${metric.tone}`} key={metric.label}>
            <span>{metric.label}</span>
            <strong>{metric.value}</strong>
          </article>
        ))}
      </div>

      <article className="activity-card" aria-labelledby="activity-title">
        <div className="activity-card-heading">
          <div>
            <span className="status-badge">{activity.status}</span>
            <h2 id="activity-title">{activity.title}</h2>
            <p>{activity.dateLabel}</p>
          </div>
          <span className="record-id">{activity.id}</span>
        </div>
        <dl className="activity-details">
          <div>
            <dt>General location</dt>
            <dd>{activity.location}</dd>
          </div>
          <div>
            <dt>Activity capacity</dt>
            <dd>{activity.capacity} people</dd>
          </div>
          <div>
            <dt>Transport</dt>
            <dd>
              {activity.transportConfirmed} of {activity.transportSeats} seats confirmed
            </dd>
          </div>
          <div>
            <dt>Data mode</dt>
            <dd>Synthetic records only</dd>
          </div>
        </dl>
      </article>
    </section>
  );
}
